import DataStore from '@ms/odsp-utilities/lib/models/store/BaseDataStore';
import DataStoreCachingType from '@ms/odsp-utilities/lib/models/store/DataStoreCachingType';
import { IView } from '@ms/odsp-datasources/lib/interfaces/view/IView';

const SP_COLUMN_SIZE = 'SPColumnSize';
const UNSAVED = '-Unsaved';

const _store = new DataStore('', DataStoreCachingType.local);

function getKey(viewId: string, getUnsaved?: boolean): string {
  const isUnsaved: string = getUnsaved ? UNSAVED : '';
  return `${SP_COLUMN_SIZE}${isUnsaved}-${viewId}`;
}

export function getColumnWidthsFromLocalStorage(viewId: string, getUnsaved?: boolean): {} {
  const key = getKey(viewId, getUnsaved);
  return _store.getValue<{}>(key);
}

export function setColumnWidthsToLocalStorage(viewId: string, columnName: string, width: number): void {
  const key = getKey(viewId, true);
  const columnSizes: { [columnName: string]: string } = getColumnWidthsFromLocalStorage(viewId, true) || {};
  columnSizes[columnName] = width.toString();
  _store.setValue(key, columnSizes);
}

export function removeColumnWidthsFromLocalStorage(viewId: string): void {
  const key = getKey(viewId, true);
  _store.remove(key);
}

export function setColumnWidthsFromViewToLocalStorage(view: IView): void {
  if (typeof DOMParser === 'undefined') {
    return;
  }
  try {
    if (view && view.baseViewXml) {
      const domParser = new DOMParser();
      const xml: Document = domParser.parseFromString(view.baseViewXml, 'text/xml');
      const columnWidths: NodeListOf<Element> = xml.getElementsByTagName('ColumnWidth');
      const columnWidth: Element = columnWidths && columnWidths[0]; // <ColumnWidth><FieldRef Name="Title" width="500" /></ColumnWidth>
      const key = getKey(view.id);

      const columnWidthObj: { [columnName: string]: string } = {};
      if (columnWidth) {
        const fieldRefs = columnWidth.getElementsByTagName('FieldRef');
        for (let i = 0; i < fieldRefs.length; i++) {
          const fieldRef: Element = fieldRefs[i];
          const name = fieldRef.getAttribute('Name');
          const width = fieldRef.getAttribute('width');
          if (name && width) {
            columnWidthObj[name] = width;
          }
        }
      }

      if (Object.keys(columnWidthObj).length) {
        _store.setValue(key, columnWidthObj);
      } else {
        _store.remove(key);
      }
    }
  } catch (e) {
    // ignore error for reading column size from local storage.
  }
}
